import { IApplicantDetails } from "@/src/types/applicant";
import { IApplyInfoComment, IRowData } from "@/src/types/applicationOnline";
import { mapApplicantHistoryItems } from "./mapApplicantHistory";

type UserInfo = IRowData["userInfo"];

const mapApplicantComments = (comments: IApplicantDetails["comments"]): IApplyInfoComment[] =>
  comments.map((comment) => ({
    id: comment.id,
    text: comment.text,
    created_at: comment.created_at,
    commentator: comment.commentator ?? "",
    commentator_role: comment.commentator_role ?? "",
    commentator_photo: comment.commentator_photo ?? null,
  }));

export const mapApplicantToUserInfo = (applicant: IApplicantDetails): UserInfo => ({
  fullname: applicant.fullname ?? "",
  fullnameNat: applicant.fullname_nat ?? "",
  form_office: applicant.form_office,
  comments: mapApplicantComments(applicant.comments),
  history: mapApplicantHistoryItems(applicant.history, applicant.id),
  documents: applicant.documents as unknown as UserInfo["documents"],
  email: applicant.email ?? "",
  phone: applicant.phone ?? "",
  course: applicant.course,
  levelEducation: applicant.level_education ?? "",
  language: applicant.language ?? "",
  country: applicant.country ?? "",
  role: applicant.role ?? "",
  nationality: applicant.nationality ?? "",
  residence: applicant.residence ?? "",
  contactPerson: applicant.contact_person ?? "",
  dateOfBirth: applicant.birth_date ?? "",
  address: applicant.address ?? "",
  passportNo: applicant.passport_number ?? "",
  passportIssued: applicant.passport_issued ?? "",
  validPassport: applicant.valid_passport ?? "",
  studentStatus: applicant.student_status ?? "",
  accounting: applicant.accounting ?? null,
  office_url: applicant.office_url ?? "",
});
